import { render, staticRenderFns } from "./UserForgetPwd.vue?vue&type=template&id=28bbc47c&"
import script from "./UserForgetPwd.vue?vue&type=script&lang=js&"
export * from "./UserForgetPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports